import React, { useState } from 'react'
import './ComponentBox.css'
import { Card, CardHeader, CardBody } from 'reactstrap'
import ICSButton from '../ICS/Button/ICSButton'
import Help from '../Help/Help'

type ComponentBoxProps = {
  title?: string
  children?: React.ReactNode
  accordion?: boolean
  help?: { title: string; text: string }
  cardClass?: string
  cardBodyId?: string
  isCustom?: boolean
}

const ComponentBox = ({
  title,
  children,
  accordion = false,
  help,
  cardClass,
  cardBodyId,
  isCustom = false
}: ComponentBoxProps) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(accordion)
  const [isHelpOpen, setIsHelpOpen] = useState(false)
  return (
    <div className={isCustom ? `${cardClass}` : 'card-container'}>
      <Card>
        {(help || title) && (
          <div className='header-container'>
            <CardHeader tag='h5' className='wivi-container-header'>
              <div className='wivi-container-title'>{title}</div>
              {help && (
                <ICSButton
                  icon='help'
                  className='component-box-help-icon'
                  type='default'
                  stylingMode='contained'
                  onClick={() => setIsHelpOpen(!isHelpOpen)}
                />
              )}
              {accordion && (
                <ICSButton
                  icon={isAccordionOpen ? 'chevrondown' : 'chevronup'}
                  type='default'
                  stylingMode='text'
                  className='component-box-accordion-icon'
                  onClick={() => setIsAccordionOpen(!isAccordionOpen)}
                  hoverStateEnabled={false}
                  height='auto'
                />
              )}
            </CardHeader>
          </div>
        )}
        <div
          className={`card-body-container ${
            accordion && !isAccordionOpen && 'card-body-hidden'
          }`}
        >
          <CardBody id={isCustom ? `${cardBodyId}` : 'cardBody'}>
            {children}
          </CardBody>
        </div>
      </Card>

      <Help
        visible={isHelpOpen}
        onHiding={() => setIsHelpOpen(!isHelpOpen)}
        title={help?.title}
      >
        <p>{help?.text && help.text}</p>
      </Help>
    </div>
  )
}

export default ComponentBox
